export default __webpack_public_path__ + "static/media/IMG_7172.cfd6697a.jpeg";